import { useMemo } from "react";
import Select from "react-select";
import { buildAutocompleteSelectStyles } from "./autocompleteSelectStyles";
import {
  resolveSelectOptions,
  filterSelectOption,
  findSelectedOption,
} from "./selectOptionUtils";

/**
 * Searchable single-select (react-select). Drop-in replacement for
 * Form.Control as="select" or native <select> — pass the same <option> children.
 */
export default function AutocompleteSelect({
  value,
  onChange,
  options,
  children,
  disabled = false,
  isInvalid = false,
  required = false,
  isClearable,
  placeholder = "Type to search…",
  className = "",
  style,
  compact = false,
  inputId,
  classNamePrefix = "ics-select",
  noOptionsMessage,
  menuPortalTarget,
}) {
  const resolved = useMemo(
    () => resolveSelectOptions({ options, children }),
    [options, children]
  );
  const selected = findSelectedOption(resolved, value);
  const clearable = isClearable !== undefined ? isClearable : !required;
  const portalTarget =
    menuPortalTarget !== undefined
      ? menuPortalTarget
      : typeof document !== "undefined"
        ? document.body
        : null;

  return (
    <div className={className} style={style}>
      <Select
        inputId={inputId}
        classNamePrefix={classNamePrefix}
        options={resolved}
        value={selected}
        onChange={(opt) => onChange(opt ? opt.value : "")}
        isDisabled={disabled}
        isClearable={clearable}
        isSearchable
        placeholder={placeholder}
        filterOption={filterSelectOption}
        styles={buildAutocompleteSelectStyles({ isInvalid, compact })}
        menuPortalTarget={portalTarget}
        menuPosition="fixed"
        noOptionsMessage={
          noOptionsMessage ||
          (({ inputValue }) => (inputValue ? "No matching options" : "No options"))
        }
      />
      {isInvalid ? (
        <div className="invalid-feedback d-block">This field is required.</div>
      ) : null}
    </div>
  );
}
